<template>
  <vs-button ref="resendButton" :size="size" :type="type" :color="color" :disabled="isDisabled" @click="handleClick">
    {{ label }}
  </vs-button>
</template>

<script>
import moment from 'moment';

export default {
  name: 'sm-interval-button',
  props: {
    label: String,
    baseTime: String,
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    interval: {
      type: Number,
      required: false,
      default: 300000 // five minutes
    },
    type: String,
    size: String,
    color: String
  },
  data () {
    return {
      isDisabled: this.disabled
    };
  },
  mounted () {
    if (!this.baseTime) return;

    const baseMoment = moment(this.baseTime);
    const now = moment().utcOffset(baseMoment.utcOffset());
    const difference = now.diff(baseMoment);

    if (difference >= this.interval) return;

    this.isDisabled = !this.isDisabled;

    setTimeout(() => {
      this.isDisabled = !this.isDisabled;
    }, this.interval - difference);
  },
  methods: {
    handleClick () {
      this.$emit('click');
    }
  }
};
</script>
